export default function scriptsHome (){


    function tabsSwap(parentWrapper, goTo){
          // TABS
       let tabs = document.querySelectorAll(`${parentWrapper} .tab`);
       let tabContents = document.querySelectorAll(`${parentWrapper} .tab-content`);
       const tabContentContainer = document.querySelector(`${parentWrapper} .tabs-content-wrapper`);
       const buttonSaibaMais = document.querySelector('.saiba-main-btn a');
        
       if(!tabs) return;
       tabs.forEach(function (tab) {
         tab.addEventListener("click", function () {
          
         
           let contentId = this.dataset.contentId;
           let  content = document.getElementById(contentId);
           buttonSaibaMais.setAttribute("href", `/solucoes?tab=${contentId}`);
           
           tabContents.forEach(function (content) {
             content.classList.remove("active");
           });
   
           tabs.forEach(function (tab) {
             tab.classList.remove("active");
           });
   
           this.classList.add("active");
           content.classList.add("active");

           let mediaQuery = window.matchMedia('(max-width: 1024px)').matches
           
           if(mediaQuery && goTo){
             tabContentContainer.scrollIntoView({behavior: "smooth"});
           }
         });
       });
    }
    // tabsSwap('#faq');
    tabsSwap('#solucoes', '#solucoes');
    

    const swiperParceiros = new Swiper ('.swiper-parceiros',{
        slidesPerView: 2,
        spaceBetween: 32,
        breakpoints:{
          740:{
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1024:{
            slidesPerView: 3,
            spaceBetween: 16,
          },
          1200:{
            slidesPerView: 4,
            spaceBetween: 32,
          }
        },
        autoplay:{
            delay: 3000,
            disableOnInteractio: false,
            // pauseOnMouseEnter: true
        }
    });
    const swiperDepoimentos = new Swiper ('.swiper-depoimentos', {
      slidesPerView: 1.2,
      spaceBetween: 16,
      // autoplay:{
          // delay: 4000,
          // disableOnInteractio: false,
          // pauseOnMouseEnter: true
      // },
      breakpoints:{
        740:{
          slidesPerView: 2.2,
          spaceBetween: 16,
        },
        1024:{
          slidesPerView: 3.2,
          spaceBetween: 16,
        },
        1200:{
          slidesPerView: 4,
          spaceBetween: 32,
        }
      },
      pagination: {
        el: ".swiper-depoimentos .swiper-pagination",
        clickable: true

      },
      navigation: {
        nextEl: ".swiper-depoimentos .custom-next",
        prevEl: ".swiper-depoimentos .custom-prev",
      },
    });

    const swiperClientes = new Swiper('.swiper-clientes', {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 24,
      loop: true,
      autoplay:{
        delay: 4000,
        disableOnInteractio: false,
        // pauseOnMouseEnter: true
      },
      pagination: {
        el: ".swiper-clientes .swiper-pagination",
        clickable: true
      },
      navigation: {
        nextEl: ".swiper-clientes .custom-next",
        prevEl: ".swiper-clientes .custom-prev",
      },
      breakpoints:{
        540:{
          slidesPerView: 3,
            spaceBetween: 24,
            slidesPerGroup: 3,
        },
        1024:{
          slidesPerView: 4,
          slidesPerGroup: 4,
            
        },
        1200:{
          slidesPerView: 6,
          slidesPerGroup: 6,
        
        }
      },
    })
    const swiperPlanos = new Swiper ('.swiper-planos', {
      slidesPerView: 1.2,
    centeredSlides: true,
    spaceBetween: 30,
    // centeredSlidesBounds: true,
    navigation: {
      nextEl: '.custom-next-planos-v2',
      prevEl: '.custom-prev-planos-v2',
    },
    pagination: {
      el: ".swiper-pagination-planos-v2",
      clickable: true,
    },
    breakpoints:{
      740:{
        slidesPerView: 2.2,
    
      },
      1024:{
        slidesPerView: 3.2,
        centeredSlides: false
      },
      1200:{
        // enabled: false,
        slidesPerView: 4,     
        navigation:  {enabled: false},
        pagination: {enabled: false},
        centeredSlides: false
      }
    },

    });
 
    /**
     * @deprecated 
    const swiperTabsFaq = new Swiper('.swiper-tabs-faq',{
      slidesPerView: 'auto',
      spaceBetween: 8,
    });
    */

    const  swiperBlog = new Swiper('.swiper-blog',{
      slidesPerView: 1.2,
      spaceBetween: 16,
      breakpoints:{
        540:{
          slidesPerView: 2,
         
        },
        1024:{
          slidesPerView: 3,
  
            
        },
        1200:{
          slidesPerView: 4,
          spaceBetween: 32,
      
        
        }
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true

      },
      navigation: {
        nextEl: ".custom-next",
        prevEl: ".custom-prev",
      },
      
    });
   

}